import { put, call, takeEvery } from 'redux-saga/effects';
import { replace, push } from 'connected-react-router';
import {
  WEBSITES_REQUEST,
  WEBSITE_REQUEST,
  CREATE_WEBSITE_REQUEST,
  UPDATE_WEBSITE_REQUEST,
  SET_WEBSITE_THEME_REQUEST,
  DELETE_WEBSITE_REQUEST,
  AVAILABLE_THEMES_REQUEST,
  WEBSITES_LIGHT_REQUEST,
} from './actionTypes';
import {
  websitesSuccess,
  websitesFailure,
  websitesLightSuccess,
  websitesLightFailure,
  websiteSuccess,
  websiteFailure,
  createWebsiteSuccess,
  createWebsiteFailure,
  updateWebsiteSuccess,
  updateWebsiteFailure,
  setWebsiteThemeSuccess,
  setWebsiteThemeFailure,
  deleteWebsiteSuccess,
  deleteWebsiteFailure,
  availableThemesSuccess,
  availableThemesFailure,
} from './actions';
import WebsiteService from '../../services/WebsitesService';

export function* getWebsitesTask() {
  try {
    const list = yield call(WebsiteService.getWebsites);
    yield put(websitesSuccess(list));
  } catch (error) {
    yield put(websitesFailure(error));
  }
}

export function* getWebsitesLightTask() {
  try {
    const list = yield call(WebsiteService.getWebsitesLight);
    yield put(websitesLightSuccess(list));
  } catch (error) {
    yield put(websitesLightFailure(error));
  }
}

export function* getWebsiteTask(action) {
  try {
    const { websiteId, editWebsite } = action.payload;
    const website = yield call(WebsiteService.getWebsite, websiteId);
    if (editWebsite) {
      yield put(push(`/website/${website.id}`));
    }
    yield put(websiteSuccess(website));
  } catch (error) {
    yield put(websiteFailure(error));
  }
}

export function* getAvailableThemesTask(action) {
  try {
    const { client } = action.payload;
    const availableThemes = yield call(
      WebsiteService.getAvailableThemes,
      client,
    );
    yield put(availableThemesSuccess(availableThemes));
  } catch (error) {
    yield put(availableThemesFailure(error));
  }
}

export function* createWebsiteTask(action) {
  try {
    const params = action.payload;
    const website = yield call(WebsiteService.createWebsite, params);
    yield put(createWebsiteSuccess(website));
    yield put(replace(`/website/${website.id}/config`));
  } catch (error) {
    yield put(createWebsiteFailure(error));
  }
}

export function* updateWebsiteTask(action) {
  try {
    const { website } = action.payload;
    const updatedWebsite = yield call(WebsiteService.updateWebsite, website);
    yield put(updateWebsiteSuccess(updatedWebsite));
  } catch (error) {
    yield put(updateWebsiteFailure(error));
  }
}

export function* setWebsiteThemeTask(action) {
  try {
    const { website } = action.payload;
    const updatedWebsite = yield call(WebsiteService.updateWebsite, website);
    yield put(setWebsiteThemeSuccess(updatedWebsite));
  } catch (error) {
    yield put(setWebsiteThemeFailure(error));
  }
}

export function* deleteWebsiteTask(action) {
  try {
    const websiteId = action.payload;
    yield call(WebsiteService.deleteWebsite, websiteId);
    yield put(deleteWebsiteSuccess(websiteId));
  } catch (error) {
    yield put(deleteWebsiteFailure(error));
  }
}

export function* websitesSaga() {
  yield takeEvery(WEBSITES_REQUEST, getWebsitesTask);
  yield takeEvery(WEBSITES_LIGHT_REQUEST, getWebsitesLightTask);
  yield takeEvery(WEBSITE_REQUEST, getWebsiteTask);
  yield takeEvery(AVAILABLE_THEMES_REQUEST, getAvailableThemesTask);
  yield takeEvery(CREATE_WEBSITE_REQUEST, createWebsiteTask);
  yield takeEvery(UPDATE_WEBSITE_REQUEST, updateWebsiteTask);
  yield takeEvery(SET_WEBSITE_THEME_REQUEST, setWebsiteThemeTask);
  yield takeEvery(DELETE_WEBSITE_REQUEST, deleteWebsiteTask);
}
